import { faDoorOpen, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import endRunSound from '../../assets/audio/Jingle_Lose_00.wav';
import navigateButton from '../../assets/audio/UI_Select_2.wav';
import { Button, Col, Row } from 'antd';
import { FC, useCallback, useState } from 'react';
import { Link } from 'react-router-dom';


import { CombatCard } from '../components/CombatCard';
import { HeroCard } from '../components/HeroCard';
import { Level } from '../components/Level';
import { getSiggImagePath } from '../hero/hero.generator';
import { LocationType } from '../locations/location.generators';
import { useAreAllEnemiesDead } from '../store/game.hooks';
import { useGameStore, useHeroStore, useLocationStore, useOptionsStore, useShopStore } from '../store/game.store';

interface PlayPageProps extends React.PropsWithChildren { }
const WarScholarPlayProps: FC<PlayPageProps> = () => {
   const { gameActions } = useGameStore();
   const { state: locationState } = useLocationStore();
   const { state: heroState } = useHeroStore();
   const areAllEnemiesDead = useAreAllEnemiesDead();
   const { state: shopState } = useShopStore();
   const { actions: optionsActions } = useOptionsStore();

   /**
    * So the audio in the browser needs a users interaction to play.
    * We add a click listener to the container that will play the audio if it is not already playing
    */
   const handleContainerClick = () => {
      optionsActions.playBackgroundMusic();
   };

   const handleEndRun = useCallback(() => {
      new Audio(navigateButton).play();
      gameActions.startNewRun();
   }, [gameActions]);

   const handleDefeat = () => {
      new Audio(endRunSound).play();
   };

   const [showModal, setShowModal] = useState(false);

   const handleHelpClick = () => {
      setShowModal(true);
   };

   const playNavigationSound = () => {
      new Audio(navigateButton).play();
   };

   return (
      <div
         className="flex-1 flex flex-col"
         onClick={handleContainerClick}
      >

         <Row className="p-1">
            <Link to="/warscholar">
               <button onClick={playNavigationSound}>
                  <FontAwesomeIcon icon={faDoorOpen} /> Back
               </button>
            </Link>
            <Button
               type="default"
               onClick={handleHelpClick}
               icon={
                  <FontAwesomeIcon
                     icon={faQuestionCircle}
                  />
               }
               className="m-1"
            >
               Help
            </Button>
         </Row>

         {showModal && (
            <div className="modal p-2">
               <p>Warsholar is a game about overcoming different obstacles and venturing out as far as you can.</p>
               <p>Be sure to spend your hard-earned gold on upgrades in the shop to help you.</p>
               <p>Check out the Book option from the main menu for the story</p>
               <p>Combat:</p>
               <p>Try out the different abilities to determine the best way to defeat your foes</p>
               <p>Each skill uses a certain amount of action points. These replenish each round.</p>
               <p>Shield bash has a chance to stun enemies. The enemy card will be tilted to the side if stunned.</p>
               <p>If stun is successful, they'll miss their turn to attack.</p>
               <p>Once a single enemy has been stunned it'll be very hard to stun that enemy again.</p>
               <p>Different enemy types have different levels of resistance to being stunned.</p>
               <button onClick={() => setShowModal(false)}>Close</button>
            </div>
         )}

         <Row className="p-1">
            <Col span={8}>
               <div className="flex justify-between">
                  <HeroCard
                     imageFilePath={getSiggImagePath()}
                     name={'Sigg'}
                  />
               </div>
               <div style={{ display: 'flex', justifyContent: 'center' }}>{shopState.gold} Gold</div>
               <div style={{ display: 'flex', justifyContent: 'center' }}>{locationState.daysVentured} Days ventured</div>
            </Col>
            <Col span={15}>
               <Level />
            </Col>
         </Row>


         {(locationState.currentLocation.locationType === LocationType.BanditAttack || locationState.currentLocation.locationType === LocationType.GobboAttack || locationState.currentLocation.locationType === LocationType.BossAttack) &&
            !areAllEnemiesDead &&
            heroState.currentHealth > 0 && <CombatCard />}

         {heroState.currentHealth === 0 && (
            <div>
               <p>Your journey comes to an end you ventured out {locationState.daysVentured} days.</p>
               <Link to="/warscholar">
                  <Button
                     type="primary"
                     onClick={handleEndRun}
                  >
                     Return to Cragknoll village
                     {handleDefeat() as any}
                  </Button>
               </Link>
            </div>
         )}
      </div>
   );
};

export const WarScholarPlayPage = WarScholarPlayProps;
